import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { stream } from '@app/_models/stream';
import { headervalue } from 'src/headervalue/header';
import {Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class StreamService {
  url: string;
  constructor(private http: HttpClient) { }

  getStream() {
    var temp = this.http.get<any>(`${environment.apiUrl}/stream/getList`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  

  addStream(documentParam: stream): Observable<stream> {
    return this.http.post<stream>(`${environment.apiUrl}/stream/streamAdd`,documentParam, httpOptions).pipe( );
  }

  updateStream(documentParam: stream): Observable<stream> {
    return this.http.post<stream>(`${environment.apiUrl}/stream/streamUpdate`,documentParam, httpOptions).pipe( );
  }

  deleteStream(id) {
    return this.http.delete<stream>(`${environment.apiUrl}/stream/deleteStreamById/`+id, httpOptions).pipe( );
  }

}